import type { HomePosterState } from '../arrival/useHomePosterSelection'
import { useI18n } from '@runtime/core/i18n/i18n'
import { DEFAULT_POSTER_THEME_ID } from '@runtime/core/theme/posterThemes'
import ActivePosterPreview from '@/components/poster/ActivePosterPreview'
import styles from './HomePlay.module.scss'
export type HomePlayProps = {
  state: HomePosterState
  scanned: boolean
  onChoose: () => void
  onOriginal: () => void
  onRetry: () => void
}
export default function HomePosterContext({
  state,
  scanned,
  onChoose,
  onOriginal,
  onRetry,
}: HomePlayProps) {
  const { t } = useI18n()
  const showPoster =
    state.status === 'ready' && (scanned || state.cfg.id !== DEFAULT_POSTER_THEME_ID)
  return (
    <>
      <div
        className={showPoster ? styles.poster : styles.heading}
        data-testid={showPoster ? 'home-active-poster' : undefined}
      >
        {showPoster && <ActivePosterPreview width={48} height={48} testId="home-poster-image" />}
        <div>
          <h2 id="home-play-title">
            {t(showPoster ? 'home.welcome.poster' : 'home.welcome.play')}
          </h2>
          {showPoster && <strong>{state.cfg.name || state.cfg.id}</strong>}
        </div>
        <button
          type="button"
          onClick={onChoose}
          aria-label={
            showPoster
              ? `${t('home.welcome.change')} — ${state.cfg.name || state.cfg.id}`
              : undefined
          }
          data-testid="home-choose-poster"
        >
          {t(showPoster ? 'home.welcome.change' : 'home.welcome.choosePoster')}
        </button>
      </div>
      {state.status !== 'ready' && (
        <section className={styles.notice} role="status" data-testid="home-poster-status">
          <p>
            {state.status === 'loading'
              ? t('home.welcome.loading')
              : t('home.welcome.' + state.status, { name: state.requested })}
          </p>
          {state.status !== 'loading' && (
            <div>
              <button type="button" onClick={onOriginal}>
                {t('home.welcome.useOriginal')}
              </button>
              <button type="button" onClick={onRetry}>
                {t('home.welcome.retry')}
              </button>
            </div>
          )}
        </section>
      )}
    </>
  )
}
